var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.4,
    viewBox: "0 0 16 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.32,15.76a2.56,2.56,0,1,1-2.56-2.56A2.56,2.56,0,0,1,18.32,15.76Z",
    transform: "translate(-7.76 -7.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6,3,7.136,4.6H4.6A1.6,1.6,0,0,0,3,6.2v9.6a1.6,1.6,0,0,0,1.6,1.6H17.4A1.6,1.6,0,0,0,19,15.8V6.2a1.6,1.6,0,0,0-1.6-1.6H14.864L13.4,3ZM11,15a4,4,0,1,1,4-4A4,4,0,0,1,11,15Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/Icon_Photo.b922e78775177906af95c409b91adc83.svg";
export { ForwardRef as ReactComponent };